import * as React from "react";
const SvgMinus = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M3.33325 12C3.33325 11.4477 3.78097 11 4.33325 11H19.6666C20.2189 11 20.6666 11.4477 20.6666 12C20.6666 12.5523 20.2189 13 19.6666 13H4.33325C3.78097 13 3.33325 12.5523 3.33325 12Z", fill: "currentColor" }));
export default SvgMinus;
